import SuspenseWrapper from '@monofe/ui-common/misc/SuspenseWrapper';
import { Fragment, memo } from 'react';
import loader from '../common/loader';
import type { ITourIndexProps as ITourIndexProperties } from './interface';
import { ITourType } from './interface';

const MainViewList = loader(() => import('./list'));
const MainViewHamburger = loader(() => import('./hamburger'));
const MainViewKeypad = loader(() => import('./keypad'));

function IndexView(properties: ITourIndexProperties): JSX.Element {
    switch (properties.type) {
        case ITourType.List:
        case ITourType.Hamburger:
        case ITourType.Keypad:
            /* Nothing to do, supported */
            break;

        case ITourType.Cascaded:
            throw new Error('Unsupported Tour Type cascaded');

        default:
            throw new Error(`Unsupported.Unrecognised tour type: ${properties.type}`);
    }

    return (
        <Fragment>
            {properties.type === ITourType.List && (
                <SuspenseWrapper fallback={null}>
                    <MainViewList {...properties.model} />
                </SuspenseWrapper>
            )}
            {properties.type === ITourType.Hamburger && (
                <SuspenseWrapper fallback={null}>
                    <MainViewHamburger {...properties.model} />
                </SuspenseWrapper>
            )}
            {properties.type === ITourType.Keypad && (
                <SuspenseWrapper fallback={null}>
                    <MainViewKeypad {...properties.model} />
                </SuspenseWrapper>
            )}
        </Fragment>
    );
}

export default memo(IndexView);
